/* Bean Shipper — subscription plan pages: Single Origin One Bag, Single Origin Two Bags and the Blend
   Subscription (sections/product__bs-sub-plan.liquid; styles in bs-sub-plan.css).
   The buy box (plan, rhythm, grind → the form's id, selling_plan and Grind property), every label
   that repeats the choice, the four scroll-driven question chapters, the question ticker jumps,
   the sticky dock, the hero parallax and the small print accordion.
   The add itself is the theme's ajax cart: form[data-bs-add] + [data-bs-pdp-add], read with FormData
   on submit, so the hidden inputs are always kept current here. Motion is transform-only. */
(function () {
  function init() {
    var root = document.querySelector('[data-b2]');
    if (!root || root.__b2) return;
    root.__b2 = true;
    root.classList.add('is-js');

    var data;
    try { data = JSON.parse(root.querySelector('[data-b2-data]').textContent); } catch (e) { return; }
    var idIn = root.querySelector('[data-b2-id]');
    var spIn = root.querySelector('[data-b2-sp]');
    var gpIn = root.querySelector('[data-b2-grindprop]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function $$(sel, el) { return Array.prototype.slice.call((el || root).querySelectorAll(sel)); }
    function each(sel, fn) { $$(sel).forEach(fn); }
    function rm(c) { return 'RM ' + (c % 100 ? (c / 100).toFixed(2) : String(c / 100)); }
    function hdr() { return window.matchMedia('(min-width: 768px)').matches ? 89 : 78; }

    var state = { plan: 'ppc', freq: data.defFreq || (data.ppc.freq[0] && data.ppc.freq[0].w), grind: data.defGrind };
    function pp(n) { for (var i = 0; i < data.prepaid.length; i++) if (String(data.prepaid[i].n) === String(n)) return data.prepaid[i]; return null; }
    function grindV(g) { for (var i = 0; i < data.ppc.grinds.length; i++) if (data.ppc.grinds[i].g === g) return data.ppc.grinds[i]; return null; }
    function freqP(w) { for (var i = 0; i < data.ppc.freq.length; i++) if (data.ppc.freq[i].w === w) return data.ppc.freq[i]; return null; }
    function weeks(w) { return w === 1 ? 'every week' : 'every ' + w + ' weeks'; }
    function cap(s) { return s.charAt(0).toUpperCase() + s.slice(1); }

    function apply() {
      var p = state.plan === 'ppc' ? null : pp(state.plan);
      if (state.plan !== 'ppc' && !p) state.plan = 'ppc';
      var g = grindV(state.grind) || data.ppc.grinds[0];
      var f = freqP(state.freq) || data.ppc.freq[0];
      var ok, name, total, note, fl;
      if (!p) {
        ok = !!(g && g.a && f);
        if (g) idIn.value = g.id;
        if (f) spIn.value = f.sp;
        gpIn.disabled = true;
        name = 'Pay per shipment';
        total = rm(data.ppc.per);
        note = 'per shipment';
        fl = f ? weeks(f.w) : '';
      } else {
        ok = true;
        idIn.value = p.id;
        spIn.value = p.sp;
        gpIn.value = state.grind;
        gpIn.disabled = false;
        name = p.n + ' shipments';
        total = rm(p.total);
        note = 'paid once · ' + rm(p.per) + ' a shipment';
        fl = 'monthly';
      }

      each('[data-b2-plan]', function (b) {
        var on = b.getAttribute('data-b2-plan') === String(state.plan);
        b.setAttribute(b.hasAttribute('aria-pressed') ? 'aria-pressed' : 'aria-checked', on ? 'true' : 'false');
      });
      each('[data-b2-freq]', function (b) {
        b.setAttribute('aria-checked', !p && Number(b.getAttribute('data-b2-freq')) === (f && f.w) ? 'true' : 'false');
        b.disabled = !!p;
      });
      each('[data-b2-grind]', function (b) { b.setAttribute('aria-checked', b.getAttribute('data-b2-grind') === state.grind ? 'true' : 'false'); });
      each('[data-b2-glrow]', function (r) { r.classList.toggle('is-sel', r.getAttribute('data-b2-glrow') === state.grind); });

      each('[data-b2-planname]', function (s) { s.textContent = name; });
      each('[data-b2-planname-lc]', function (s) { s.textContent = name.toLowerCase(); });
      each('[data-b2-freqlabel]', function (s) { s.textContent = fl; });
      each('[data-b2-freqlabel-cap]', function (s) { s.textContent = cap(fl); });
      each('[data-b2-grindlabel]', function (s) { s.textContent = state.grind; });
      each('[data-b2-grindlabel-lc]', function (s) { s.textContent = state.grind.toLowerCase(); });
      each('[data-b2-total]', function (s) { s.textContent = total; });
      each('[data-b2-totalnote]', function (s) { s.textContent = note; });
      // FIRSTTASTE and "cancel anytime" belong to pay per shipment only; prepaid shows its own line.
      each('[data-b2-ft], [data-b2-ftnote]', function (s) { s.hidden = !!p; });
      each('[data-b2-pponly], [data-b2-pp-note]', function (s) { s.hidden = !p; });
      each('[data-b2-ppn]', function (s) { s.textContent = p ? p.n : ''; });
      // Button labels live inside the add buttons, which the ajax cart restores from innerHTML
      // after an add, so they are re-queried on every pass.
      each('[data-b2-cta1]', function (s) { s.textContent = p ? 'Start · ' + name + ' · ' + total : 'Start · Pay per shipment · ' + total; });
      each('[data-b2-cta2]', function (s) { s.textContent = p ? 'Start: ' + total + ' for ' + p.n + ' shipments' : 'Start: ' + total + ' per shipment'; });
      each('[data-bs-pdp-add]', function (b) { b.disabled = !ok; });

      // Next eight weeks: shipments on the chosen rhythm (prepaid ≈ every 4 weeks), the second one skipped.
      var step = p ? 4 : (f ? f.w : 3), n = 0;
      each('[data-b2-cal] span', function (s) {
        var w = Number(s.getAttribute('data-w'));
        var ship = (w - 1) % step === 0;
        if (ship) n++;
        s.classList.toggle('is-ship', ship && !(n === 2 && !p));
        s.classList.toggle('is-skip', ship && n === 2 && !p);
      });
    }

    // Clicks: plan, rhythm, grind, question jumps, chapter question list, FAQ.
    root.addEventListener('click', function (e) {
      var t = e.target, b;
      if ((b = t.closest('[data-b2-plan]'))) { state.plan = b.getAttribute('data-b2-plan'); apply(); return; }
      if ((b = t.closest('[data-b2-freq]'))) { if (!b.disabled) { state.freq = Number(b.getAttribute('data-b2-freq')); apply(); } return; }
      if ((b = t.closest('[data-b2-grind]'))) { state.grind = b.getAttribute('data-b2-grind'); apply(); return; }
      if ((b = t.closest('[data-b2-jump]'))) { var j = b.getAttribute('data-b2-jump').split('~'); jumpTo(Number(j[0]), Number(j[1])); return; }
      if ((b = t.closest('.b2-qs li[data-b2-q]'))) {
        var ch = b.closest('[data-b2-ch]');
        jumpTo(Number(ch.getAttribute('data-b2-ch')), Number(b.getAttribute('data-b2-q')));
        return;
      }
      if ((b = t.closest('[data-b2-faqq]'))) {
        var it = b.closest('.b2-faq__i'), open = !it.classList.contains('is-open');
        it.classList.toggle('is-open', open);
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
    });
    // Keyboard: arrow keys move between radios in a group (they are buttons, so Enter/Space already work).
    root.addEventListener('keydown', function (e) {
      if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown'].indexOf(e.key) < 0) return;
      var r = e.target.closest('[role="radio"]');
      if (!r) return;
      var grp = $$('[role="radio"]:not([disabled])', r.parentNode);
      var i = grp.indexOf(r) + (e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 1);
      var nx = grp[(i + grp.length) % grp.length];
      if (nx) { e.preventDefault(); nx.focus(); nx.click(); }
    });

    // ---- Chapters ----
    var chapters = $$('[data-b2-ch]').map(function (el) {
      return {
        el: el,
        stick: el.querySelector('.b2-ch__stick'),
        stage: el.querySelector('.b2-stage'),
        texts: $$('.b2-t', el),
        vis: $$('.b2-v', el),
        qs: $$('.b2-qs li', el),
        prog: el.querySelector('[data-b2-prog]'),
        qn: el.querySelector('[data-b2-qn]'),
        base: Number(el.getAttribute('data-base')) || 0,
        idx: -1
      };
    });
    function scrolly(c) { return c.el.classList.contains('is-scrolly'); }
    // Scroll-driven only when the tallest question and visual fit the screen; otherwise stacked.
    // 19 Oct 2026: the fit is measured on a hidden copy parked off screen. Switching is-scrolly on
    // the live chapter, measuring and switching it back logged a layout shift of about 0.27 per
    // chapter on every fit (script start, fonts, load, resize): CLS 0.55 at 390px, 0.95 at 360px.
    // The live chapter now only changes when the answer changes.
    function fits(c) {
      if (!c.stick || !c.stage) return false;
      var cl = c.el.cloneNode(true);
      cl.classList.add('is-scrolly');
      Array.prototype.forEach.call(cl.querySelectorAll('.is-on, .is-past'), function (x) { x.classList.remove('is-on', 'is-past'); });
      cl.setAttribute('aria-hidden', 'true');
      cl.style.position = 'absolute';
      cl.style.top = '0';
      cl.style.left = '-300vw';
      cl.style.width = c.el.offsetWidth + 'px';
      cl.style.visibility = 'hidden';
      cl.style.pointerEvents = 'none';
      c.el.parentNode.insertBefore(cl, c.el);
      var st = cl.querySelector('.b2-ch__stick'), sg = cl.querySelector('.b2-stage');
      var ok = !(sg.scrollHeight > sg.clientHeight + 1 || st.scrollHeight > st.clientHeight + 1);
      cl.parentNode.removeChild(cl);
      return ok;
    }
    function fit() {
      chapters.forEach(function (c) {
        var want = !(reduce || window.innerHeight < 560) && fits(c);
        if (want === scrolly(c)) return;
        c.el.classList.toggle('is-scrolly', want);
        c.idx = -1;
        c.texts.concat(c.vis).forEach(function (x) { x.classList.remove('is-on', 'is-past'); });
      });
    }
    function setIdx(c, i) {
      if (i === c.idx) return;
      c.idx = i;
      [c.texts, c.vis].forEach(function (list) {
        list.forEach(function (x, k) { x.classList.toggle('is-on', k === i); x.classList.toggle('is-past', k < i); });
      });
      c.qs.forEach(function (q, k) { q.classList.toggle('is-on', k === i); });
      if (c.qn) c.qn.textContent = c.base + i + 1;
    }
    function chRange(c) {
      var top = c.el.getBoundingClientRect().top + window.pageYOffset - hdr();
      var len = c.el.offsetHeight - c.stick.offsetHeight;
      return { top: top, len: Math.max(1, len) };
    }
    function runChapters() {
      chapters.forEach(function (c) {
        if (!scrolly(c)) return;
        var r = chRange(c), n = c.texts.length;
        var p = Math.min(1, Math.max(0, (window.pageYOffset - r.top) / r.len));
        setIdx(c, Math.min(n - 1, Math.floor(p * n)));
        if (c.prog) c.prog.style.transform = 'scaleX(' + p.toFixed(4) + ')';
      });
    }
    function jumpTo(ci, qi) {
      var c = chapters[ci];
      if (!c) return;
      var y;
      if (scrolly(c)) {
        var r = chRange(c), n = c.texts.length;
        y = r.top + ((qi + 0.5) / n) * r.len;
      } else {
        var t = c.texts[qi] || c.el;
        y = t.getBoundingClientRect().top + window.pageYOffset - hdr() - 16;
      }
      try { window.scrollTo({ top: y, behavior: reduce ? 'auto' : 'smooth' }); } catch (e) { window.scrollTo(0, y); }
    }

    // ---- Dock: on whenever the hero buy box's Start button is off screen (so first paint on a laptop
    // or phone already has a Start button), off while the plans CTA or the closing block is showing ----
    var bar = root.querySelector('[data-b2-dock]');
    var sum = root.querySelector('.b2-cfg__sum');
    var fin = root.querySelector('[data-b2-final]');
    var plansCta = root.querySelector('.b2-plansec__cta');
    var dockOn = null;
    function setDock(on) {
      if (!bar || on === dockOn) return;
      dockOn = on;
      bar.setAttribute('data-on', on ? 'true' : 'false');
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      $$('button', bar).forEach(function (b) { b.tabIndex = on ? 0 : -1; });
    }
    function runDock() {
      if (!bar || !sum || !fin) return;
      var vh = window.innerHeight;
      var sr = sum.getBoundingClientRect();
      var sumOn = sr.top < vh && sr.bottom > hdr();
      var finOn = fin.getBoundingClientRect().top < vh;
      var pr = plansCta ? plansCta.getBoundingClientRect() : null;
      var plansOn = pr ? pr.top < vh && pr.bottom > hdr() : false;
      setDock(!sumOn && !finOn && !plansOn);
    }

    // ---- Hero photo parallax (desktop, while the hero is on screen) ----
    var par = root.querySelector('[data-b2-parallax]');
    var hero = root.querySelector('.b2-hero');
    function runParallax() {
      if (!par || reduce || !window.matchMedia('(min-width: 1024px)').matches) { if (par) par.style.transform = ''; return; }
      var r = hero.getBoundingClientRect();
      if (r.bottom < 0) return;
      par.style.transform = 'translate3d(0,' + (Math.max(0, -r.top) * -0.06).toFixed(1) + 'px,0)';
    }

    var ticking = false;
    function frame() { ticking = false; runChapters(); runDock(); runParallax(); }
    function queue() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    var rt = 0;
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', function () {
      clearTimeout(rt);
      rt = setTimeout(function () { fit(); frame(); }, 150);
    });

    apply();
    fit();
    frame();
    // Web fonts can change text heights after first paint: fit once more when they settle.
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fit(); frame(); });
    window.addEventListener('load', function () { fit(); frame(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
